import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	scheduleActionsCloser: {
		id: 'eoc-on-call.tours.schedule-actions.schedule-actions-closer',
		defaultMessage: 'Schedule actions are closer',
		description: 'Title of schedule actions spotlight.',
	},
	findAllScheduleManagement: {
		id: 'eoc-on-call.tours.schedule-actions.find-all-schedule-management',
		defaultMessage:
			'Find all schedule management actions in the actions menu. Quickly access your rotations by editing the schedule.',
		description: 'Description of schedule actions spotlight.',
	},
});
